import BaseItemView from 'app/src/views/base/BaseItemView';
import Format from 'root/apps/helpers/format';
import Modules from 'shared_modules/Modules';

import paymentTotalViewTemplate from './templates/payment-total-view.hbs';

const _Events = {
  REMOVE_DEPOSITS_CLICKED: 'remove:deposits:clicked',
  EDIT_DEPOSITS_CLICKED: 'edit:deposits:clicked',
};

// configure
let View = BaseItemView.extend({
  template: paymentTotalViewTemplate,

  ui: {
    saleTotal: '#sale_total',
    paymentsTotal: '#payments_total2',
    balance: '#sale_balance',
    deposit: '#account_deposit_row',
    depositTitle: '#account_deposit_title',
    depositRefund: '#account_withdraw_row',
    depositAmount: '#account_deposit_cell',
    depositBtn: '#account_deposit_btn',
    depositRefundAmount: '#account_withdraw_cell',
    removeDepositsButton: '#totalsRemoveDepositButton',
    tipTotal: '#tip_total',
    surchargeTotal: '#surcharge_total',
    cashRoundingDelta: '#cashRoundingDelta',
    cashRoundingDeltaRow: '#cashRoundingDeltaRow',
    cashRoundedBalance: '#cashRoundedBalance',
    cashRoundingBalanceRow: '#cashRoundingBalanceRow',
  },

  triggers: {
    'click @ui.removeDepositsButton': _Events.REMOVE_DEPOSITS_CLICKED,
  },
});

// define
export default class PaymentTotalView extends View {
  onRender(view) {
    if (Modules.hasModule('customers.invoicing_integration.free_tier')) {
      this.ui.depositBtn.hide();
      this.ui.depositAmount.hide();
    } else {
      this.ui.depositBtn.show();
      this.ui.depositAmount.show();
    }
  }

  static get Event() {
    return _Events;
  }

  /**
   * Update the Sale Total
   *
   * @param amount {Decimal} The total Sale amount
   */
  updateSaleTotal(amount) {
    this.ui.saleTotal.text(Format.toMoney(amount));
  }

  updateTipAmount(amount) {
    this.ui.tipTotal.text(Format.toMoney(amount));
  }

  updateSurchargeAmount(amount) {
    this.ui.surchargeTotal.text(Format.toMoney(amount));
  }

  /**
   * Update the displayed payments total.
   *
   * @param amount {Decimal}  The total payments on a sale
   */
  updateTotal(amount) {
    this.ui.paymentsTotal.text(Format.toMoney(amount));
  }

  /**
   * Updates the balance displayed in the view.  It will show negative balances
   * as zero.
   *
   * @param amount {Decimal}  The balance for a sale
   */
  updateBalance(amount) {
    if (amount.isZero()) {
      this.ui.balance.removeClass('red').addClass('green');
    } else {
      this.ui.balance.removeClass('green').addClass('red');
    }

    this.ui.balance.text(Format.toMoney(amount));
  }

  /**
   * Shows or hides the deposit UI
   *
   * @param {boolean} show    When true will show the UI
   */
  showDeposits(show = true) {
    if (show) {
      this.ui.deposit.show();
    } else {
      this.ui.deposit.hide();
    }
  }

  enableRemoveDeposits(enabled = true) {
    if (enabled) {
      this.ui.removeDepositsButton.prop('disabled', false);
    } else {
      this.ui.removeDepositsButton.prop('disabled', true);
    }
  }

  /**
   * Sets the deposit amount
   *
   * @param {Decimal} amount  The deposit amount
   */
  setDepositAmount(amount) {
    this.ui.depositAmount.text(Format.toMoney(amount));
  }

  /**
   * Shows or hides the deposit UI
   *
   * @param {boolean} show    When true will show the UI
   */
  showDepositRefunds(show = true) {
    if (show) {
      this.ui.depositRefund.show();
    } else {
      this.ui.depositRefund.hide();
    }
  }

  /**
   * Sets the deposit amount
   *
   * @param {Decimal} amount  The deposit amount
   */
  setDepositRefundAmount(amount) {
    this.ui.depositRefundAmount.text(Format.toMoney(amount));
  }

  /**
   * Sets the deposit title
   *
   * @param {string} title    The title to use for the deposit total
   */
  setDepositTitle(title) {
    this.ui.depositTitle.text(title);
  }

  setCashRoundingDelta(amount) {
    this.ui.cashRoundingDelta.text(Format.toMoney(amount));
  }

  setCashRoundedBalance(amount) {
    if (amount.isZero()) {
      this.ui.cashRoundedBalance.removeClass('red').addClass('green');
    } else {
      this.ui.cashRoundedBalance.removeClass('green').addClass('red');
    }

    this.ui.cashRoundedBalance.text(Format.toMoney(amount));
  }

  showCashRoundingInfo(show) {
    if (show) {
      this.ui.cashRoundingDeltaRow.show();
      this.ui.cashRoundingBalanceRow.show();
    } else {
      this.ui.cashRoundingDeltaRow.hide();
      this.ui.cashRoundingBalanceRow.hide();
    }
  }
}
